var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{ref:"editor",staticClass:"editor-wrapper"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }